export default function CountryCodeRow({ index, style, filteredData, onClick }) {
    const country = filteredData?.[index];
    console.log("Country Row: ",index, country, filteredData);

    if(!country) return null;
    return (
        <div
            style={style}
            className="cc-item"
            onClick={() => onClick(country)}
        >
            <img
                src={`https://flagcdn.com/w20/${country.iso2}.png`}
                alt=""
            />
            <span className="name">{country.name}</span>
            <span className="dial">+{country.dialCode}</span>
        </div>
    );
}